import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { InfoCardItem } from './info-card.reducer';

export const infoCardActions = {
  load1: createAction('load/info-card-1/load'),
  done1: createAction('load/info-card-1/done', props<{ state: ILoaderActionPayload; data?: InfoCardItem }>()),
  load2: createAction('load/info-card-2/load'),
  done2: createAction('load/info-card-2/done', props<{ state: ILoaderActionPayload; data?: InfoCardItem }>()),
  load3: createAction('load/info-card-3/load'),
  done3: createAction('load/info-card-3/done', props<{ state: ILoaderActionPayload; data?: InfoCardItem }>()),
  load4: createAction('load/info-card-4/load'),
  done4: createAction('load/info-card-4/done', props<{ state: ILoaderActionPayload; data?: InfoCardItem }>()),
};
